import './star-rating.less';

export const starRatingComponentModule = angular
  .module('Q.components.star-rating', [])

  .component('starRating', {
    bindings: {
      stars: '<',
    },
    require: {
      ngModelCtrl: 'ngModel',
    },
    controller: 'StarRatingCtrl',
    template: '<div class="star-rating-root"></div>',
  })

  .controller('StarRatingCtrl', function StarRatingCtrl($element, $scope) {
    const ctrl = this;

    ctrl.$onInit = ctrl.$onChanges = () => {
      const ngModelCtrl = ctrl.ngModelCtrl;
      const maxStars = +ctrl.stars || 5;
      let stars = [];

      const readonly = () =>
        $element.attr('disabled') || $element.attr('readonly');

      const render = (ngModelCtrl.$render = (
        value = ngModelCtrl.$viewValue,
      ) => {
        // renders all stars at or below the value as active
        stars.forEach((s, i) => {
          s.toggleClass('star-rating-active', i <= value);
        });
      });

      const root = $element.querySelector('.star-rating-root');
      root.empty();

      // render all stars, including a 0-value "star" for clearing the value
      for (let value = 0; value <= maxStars; value++) {
        const star = angular.element(
          `<span class="star-rating-star star-rating-star-${value}">`,
        );
        root.append(star);
        stars.push(star);

        // Star selection. We include mouseup so the user can drag the mouse around to the value they want,
        // like a slider
        star.on('click mouseup', () => {
          if (readonly()) return;
          render(value);
          $scope.$applyAsync(() => {
            if (value !== ngModelCtrl.$viewValue) {
              ngModelCtrl.$setViewValue(value);
            }
          });
        });

        star.on('mouseenter', () => {
          if (readonly()) return;
          // highlight every start at or below this one
          stars.forEach((s, i) => {
            s.toggleClass('star-rating-hover', i <= value);
          });
        });

        star.on('mouseleave', () => {
          // clear all star hover markers (will be triggered immediately before mouseenter, so there's no
          // fear of flickering
          stars.forEach((s) => {
            s.toggleClass('star-rating-hover', false);
          });
        });
      }

      render();
    };
  });
